/*
    AGA.Menu
    Utilizado para quebrar os TABS das páginas auto geradas do RH.
    Destaca a página selecionada    
 */

AGA.Menu = (function () {

    var lastAgaMenuStack = [];

    function changeTabActive(tab, cur) {
        tab.uniqueId();
        var tabId = $(tab).attr("id");
        var found = false;
        for (var i = 0; i < lastAgaMenuStack.length; i++) {
            if (lastAgaMenuStack[i].key === tabId) {
                if (lastAgaMenuStack[i].item !== cur)
                    $(lastAgaMenuStack[i].item).parent().removeClass("active");
                lastAgaMenuStack[i].item = cur;
                found = true;
            }
        }
        if (!found)
            lastAgaMenuStack.push({ key: tabId, item: cur });
    };

    function hideOtherItems(currentLiId) {
        var li = $(currentLiId);
        var lisToNotHide = [currentLiId];
        for (var i = 0; i <= 50; i++) { // previnir loop infinito
            if (!li.parent().hasClass('aga-submenu'))
                break;
            var topParent = li.parent().parent();
            if (!topParent.is('li'))
                break;
            lisToNotHide.push('#' + $(topParent).attr('id'));
        }
        var todosLi = $("ul.aga-submenu li.open");
        for (var i = 0; i < todosLi.length; i++)
        {
            var currLi = $(todosLi[i]);
            if (lisToNotHide.includes('#' + currLi.attr('id')))
                continue;
            currLi.removeClass('open');
        }

    }

    function detailClickEvent(e) {
        detailClick(e.target, false);
    }

    function detailClick(target, isPropagating) {
        var theTab = $(target).parent().closest('.aga-tabs');

        changeTabActive(theTab, target);

        $(theTab.find('a')).removeClass('aga-a-active');
        if (!isPropagating)
            $(theTab.find('span.aga-sel')).empty();
        $($(theTab).find('a')).removeClass('aga-a-active');

        // Verifica se esta dentro de grupo
        var theDropDown = $(target).parent().parent().hasClass('aga-tab-dropdown') ? $(target).parent().parent() : null;
        if (theDropDown != null) {
            var id = '#' + $(theDropDown).attr("aria-labelledby");
            var firstSpan = $(id).children().first();
            if ($(id).children().length > 2)
                firstSpan.next().text(' | ' + $(target).text());
            else
                firstSpan.after('<span class="aga-sel aga-a-active"> | ' + $(target).text() + '</span>');

            if ($(theDropDown).hasClass('aga-submenu-inner')) {
                detailClick($(id), true);
            }
        }

        // Marcar item
        $(target).closest('a').addClass('aga-a-active');
    };

    function getItems(theUL) {
        var todosLI = [];
        var grupos = [];

        $(theUL).children("li").each(function (idx, li) {
            var s = $(li).text();
            var pos = s.indexOf('>');
            if (pos > 0) {
                var sGrupo = s.substring(0, pos);
                var sCaption = s.substring(pos + 1, 100);
                if (grupos.indexOf(sGrupo) < 0) {
                    grupos.push(sGrupo);
                }
                todosLI.push({ "li": li, "grupo": sGrupo, "caption": sCaption });
            }
        });

        return {
            todosLI: todosLI,
            grupos: grupos
        };
    };

    function createNewUL(caption, parent, isSubMenu) {
        var li = document.createElement("li");
        var a = document.createElement("a");
        $(a).uniqueId();
        script = '';
        var ulClasses = "dropdown-menu aga-tab-dropdown";
        var iClasses = "fa fa-angle-down";
        if (isSubMenu) {
            $(li).uniqueId();
            script = " AGA.Menu.forceOpenMenu('" + $(li).attr("id") + "')";
            ulClasses = ulClasses + " aga-breaked-menu aga-submenu";
            iClasses = "fa fa-angle-right";
        }
        $(a).addClass("dropdown-toggle")
            .attr({
                "href": "javascript:" + script+";",
                "data-toggle": "dropdown",
                "aria-expanded": "false"
            })
            .appendTo(li);

        var span = document.createElement("span");
        $(span).text(caption).appendTo(a);
        $(document.createElement("i")).addClass(iClasses).appendTo(a);
        var ul = document.createElement("ul");
        $(ul).addClass(ulClasses)
            .attr({ "role": "menu", "aria-labelledby": $(a).attr("id") })
            .appendTo(li);
        $(parent).append(li);
        

        return ul;
    };

    function breakMenuUL(theUL, isSubMenu) {
        var obj = getItems(theUL);

        var todosLI = obj.todosLI;
        var grupos = obj.grupos;

        if (grupos.length === 0)
            return;

        for (var i = 0; i < grupos.length; i++) {
            var grupoAtual = grupos[i];

            var ul = createNewUL(grupoAtual, theUL, isSubMenu);

            for (var i2 = 0; i2 < todosLI.length; i2++) {
                var atual = todosLI[i2];
                if (atual.grupo === grupoAtual) {
                    $(atual.li).find("a").first().text(atual.caption);
                    $(atual.li).appendTo(ul);
                }
            }

            if ($(theUL).hasClass('aga-submenu')) {
                var subItems = getItems(ul);
                if (subItems.grupos.length > 0) {
                    $(ul).addClass("aga-breaked-menu aga-submenu");
                    breakMenuUL(ul, true);
                }
                if (isSubMenu)
                    $(ul).addClass("aga-submenu-inner");
            }

        }

    };

    return {
        init: function () {
            $(document).on("click", "li.aga-li", detailClickEvent);
            AGA.Menu.breakMenus();
            AGA.Menu.activeFirstTabs();
        },

        activeFirstTabs: function () {
            $(".aga-tabs").each(function () {
                if ($(this).find("li.active").length === 0 && $(this.parentNode).closest(".tab-content").length === 0) {
                    var x = $(this).find("li");
                    if (x.length > 0) {
                        var tabRoot = $(this).find("li:first").find(":first-child");
                        if (tabRoot.find(":first-child").length === 0)
                            tabRoot.trigger("click");
                        else
                            tabRoot.find(":first-child").trigger("click");
                    }
                }
            });
        },

        breakMenus: function () {
            $("#ContentPanel .aga-tabs:not(.aga-breaked-menu)").each(
                function (ulIndex, theUL) {
                    $(theUL).addClass("aga-breaked-menu");
                    breakMenuUL(theUL, false);
                });
        },

        forceOpenMenu: function (id) {
            var id = "#" + id;
            $(id).toggleClass("open");
            $(id + " ul").attr("style", "top: " + $(id).position().top + "px;");
            hideOtherItems(id);
        }

    };

})();

